const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the myreports component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('circlestat', [function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      value: '=',
      headline: '=',
      subtitle: '=',
      modifier: '=',
      type: '=?'
    },
    template: require('../../templates/directives/circlestat.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.isMaxed = false;
      self.type = $scope.type;

      self.setValue = function(input){
        if(self.type === 'percent') {
          if (input === "100%" || parseInt(input.substring(0, input.length - 1)) % 1 !== 0 ) {
            self.isMaxed = true;
          }
        }
        self.value = input;
      };

      $scope.$watch('value', function(myVal) {
        if(myVal) { 
            self.setValue(myVal)
        }
        else {
          self.setValue('');
        }        
      });
    }],
    controllerAs: 'stat'
  };
}]);
